// generated file, if you want to edit this file manually change the word "generated" to "manual"

import SelectInputBase from '@mui/material/InputBase';
import MaterialSelect from '@mui/material/Select';
import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForSelect = makeThemedStyles('FormControl.Select', () => ({
  Select: {
    margin: '0px',
    borderBottom: '3px solid #18636b',
    marginLeft: '20px',
    paddingLeft: '30px',
    fontSize: '12px',
    fontWeight: 'bold',
    '& .MuiSelect-select': { display: 'flex', alignItems: 'center' },
    '& .MuiSelect-select:focus': { background: 'none' }
  },

  xl: {
    paddingLeft: '0px',
    fontSize: '2em',
    marginLeft: '0px',
    color: '#18636b',
    borderBottom: 'none'
  },
  roundedWhite: {
    border: 'none',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '10px'
  }
}));

type PropType = React.ComponentProps<typeof MaterialSelect>;

export const Select: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForSelect();

  // Pick classes from the theme if they are defined
  // const theme = useTheme();
  // const themeObj = (theme as any)?.qpr?.FormControl?.Select
  const enabledClasses: { [key: string]: string } = {};
  const variants = ['Select', 'xl', 'roundedWhite'];
  Object.keys(styles || {})
    .filter(key => !variants.includes(key))
    .forEach(key => {
      if ((styles as any)[key]) {
        enabledClasses[key] = (styles as any)[key];
      }
    });

  /* eslint-disable */
  return (
    <MaterialSelect
      {...props}
      input={
        <SelectInputBase
          classes={{ root: styles.Select, ...enabledClasses }}
          className={clsx(styles.Select, {
            [styles.xl]: isVariantEnabled(props, 'xl'),
            [styles.roundedWhite]: isVariantEnabled(props, 'roundedWhite')
          })}
        />
      }
      onChange={props.onChange}
      className={clsx(styles.Select, {
        [styles.xl]: isVariantEnabled(props, 'xl'),
        [styles.roundedWhite]: isVariantEnabled(props, 'roundedWhite')
      })}
      value={props.value}
    >
      {props?.children}
    </MaterialSelect>
  );
};
export default Select;
